import AddRssDialog from './AddRssDialog';
import RssDataTable from './RssDataTable';
import Layout from '../../Layout/Layout';

import { useSelector, useDispatch } from 'react-redux';
import { useDataTableContext } from '../../Contexts/DataTableContext';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';

import "../css/apps.css";
import { useMemo } from 'react';
import { IoNewspaperOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import FeatureLocked from '../../SharedComponents/FeatureLocked';

function RssIndex() {
    const { t } = useTranslation();
    const openDialog = useSelector((state) => state.global.openDialog);
    const dispatch = useDispatch()

    const { getDataTable } = useDataTableContext();

    const subNavbarContent = useMemo(() => {
        return (
            <div className='flex justify-end w-100'>
                <button className="btn btn-primary mx-1" disabled={getDataTable.isLoading}
                 onClick={() => dispatch(toggleDialog("rssFeedAddition"))} > {t('rss.add_new_rss')}</button>
            </div>)
    }, [getDataTable.isLoading]);

    const subNavbarProps = useMemo(() => {
        return {
            icon: <IoNewspaperOutline className='text-secondary  fs-2' /> || " ",
        };
    }, []);

    if (getDataTable.error?.response?.status === 402) {
        return (
            <Layout>
                <FeatureLocked feature="rss_feed" message={getDataTable.error.response.data?.message} />
            </Layout>
        );
    }

    return (
        <Layout subNavbarProps={subNavbarProps} subNavbarContent={subNavbarContent}>
            <div className="card">

                <div className=" d-flex flex-column  m-4">
                    <RssDataTable />
                </div>
            </div>
            {openDialog.rssFeedAddition ? <AddRssDialog /> : <></>}
        </Layout >
    )
}

export default RssIndex